import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2swamazng: FaireProductEntity = {
  token: "p_x2swamazng",
  type: "product",
  name: "Champ Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1778d82458a837b9232f37376e6902ee9c875aaadd1a6b3ccca03a75865eb1d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff9f6bee88bf57793924e12865be44ff772ac57599396e17ee41ae8f6d206247.jpeg",
    "https://cdn.faire.com/fastly/3244a4abbd22c4e9ea94ff18301c58b4f4f72e12fa11183080dfe6ef1861cb37.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/675ff2fd724dd0c8953c029b63b2a1219273410d6cd1b98884c50392f46711f7.jpeg",
    "https://cdn.faire.com/fastly/99d1beaee4bb2316ec8f602c4387d891045af2df6f0b814079b1071818a16f06.jpeg",
    "https://cdn.faire.com/fastly/5903da52987bc6802618b3816879ab0e6da9a5850162405fa666790d34378dfe.jpeg",
    "https://cdn.faire.com/fastly/9e175da29ed2e4dfab287f32206c3d862695685da61c4f5e20e5ff87d8ffdc54.jpeg"
  ],
  priceDollars: 6.75,
  description: "You deserve a trophy for putting your socks on every day... But let's face it, you can't wear a trophy.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:21.985Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
